import React, { useState, useEffect } from 'react';
import "../pages/css/DashBoard.css";
import Header from '../pages/components/Header';
import SideBar from '../pages/components/SideBar';
import { getDatabase, ref, get, update } from "firebase/database";
import UserVerification from '../pages/components/UserVerification';
import { useNavigate } from "react-router-dom";
import { Table, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';

function WithdrawlRequests() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [requests, setRequests] = useState([]);
    const navigate = useNavigate();

    UserVerification();
    const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

    useEffect(() => {
        const db = getDatabase();
        const usersRef = ref(db, "blackstone-users/");

        get(usersRef).then(snapshot => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const allRequests = [];

                Object.keys(data).forEach(uid => {
                    const user = data[uid];
                    const withdrawRequests = user.withdrawlRequest || {};

                    Object.keys(withdrawRequests).forEach(key => {
                        const request = withdrawRequests[key];
                        allRequests.push({
                            uid,
                            username: user.username || "N/A",
                            email: user.email || "N/A",
                            phone: user.phone || "N/A",
                            ...request,
                            key, // generated key for status updates
                        });
                    });
                });

                setRequests(allRequests);
            }
        }).catch(error => {
            console.error("Error fetching withdraw requests:", error);
        });
    }, []);

    const handleStatusChange = async (uid, key, currentStatus) => {
        const db = getDatabase();
        const requestRef = ref(db, `blackstone-users/${uid}/withdrawlRequest/${key}`);
        const newStatus = currentStatus === "pending" ? "paid" : "pending";

        try {
            await update(requestRef, { status: newStatus });

            // Update frontend state
            setRequests(prev =>
                prev.map(r => r.uid === uid && r.key === key ? { ...r, status: newStatus } : r)
            );

            Swal.fire(
                "✅ Success",
                `Withdrawal status changed to ${newStatus}`,
                "success"
            );
        } catch (err) {
            console.error("Error updating status:", err);
            Swal.fire("❌ Error", "Failed to update status", "error");
        }
    };

    const handleViewDetails = (request) => {
        Swal.fire({
            title: "💰 Withdraw Details",
            html: `
                <p><strong>Coin:</strong> ${request.coin || "N/A"}</p>
                <p><strong>INR Equivalent:</strong> ₹${request.inrAmount?.toLocaleString() || "N/A"}</p>
                <p><strong>UPI / Binance ID:</strong> ${request.upiId || "N/A"}</p>
                <p><strong>Requested At:</strong> ${request.requestedAt || "N/A"}</p>
                <p><strong>Status:</strong> ${request.status || "N/A"}</p>
            `,
            icon: "info",
            confirmButtonText: "Close"
        });
    };

    return (
        <div className="d-flex layout-container">
            <SideBar isOpen={isSidebarOpen} />
            <div className="flex-grow-1">
                <Header onMenuClick={toggleSidebar} />
                <div className="scrollable-section">
                    <div className="p-4 shadow-md bg-white rounded" style={{ maxWidth: '1300px' }}>
                        <h3 className="mb-4 fw-bold">Withdrawal Requests</h3>

                        <Table bordered hover size="sm" striped responsive style={{ fontSize: '0.875rem' }}>
                            <thead className="table-dark">
                                <tr>
                                    {/* <th>UID</th> */}
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Coin</th>
                                    {/* <th>Amount</th> */}
                                    <th>INR Equivalent</th>
                                    <th>UPI ID</th>
                                    <th>Requested At</th>
                                    <th>Status</th>
                                    <th>Change Status</th>
                                    <th>View Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requests.length > 0 ? requests.map(r => (
                                    <tr key={`${r.uid}-${r.key}`}>
                                        {/* <td>{r.uid}</td> */}
                                        <td>{r.username}</td>
                                        <td>{r.email}</td>
                                        <td>{r.phone}</td>
                                        <td>{r.coin || "N/A"}</td>
                                        {/* <td>{r.amount || "N/A"}</td> */}
                                        <td>₹{r.inrAmount?.toLocaleString() || "N/A"}</td>
                                        <td>{r.upiId || "N/A"}</td>
                                        <td>{new Date(r.requestedAt).toLocaleString() || "N/A"}</td>
                                        <td>
                                            {r.status === "paid" 
                                                ? <span className="text-success fw-bold">Paid</span>
                                                : <span className="text-warning fw-bold">Pending</span>
                                            }
                                        </td>
                                        <td>
                                            <Button
                                                size="sm"
                                                variant={r.status === "paid" ? "warning" : "success"}
                                                onClick={() => handleStatusChange(r.uid, r.key, r.status)}
                                            >
                                                {r.status === "paid" ? "Set Pending" : "Set Paid"}
                                            </Button>
                                        </td>
                                        <td>
                                            <Button
                                                size="sm"
                                                variant="info"
                                                onClick={() => handleViewDetails(r)}
                                            >
                                                View Details
                                            </Button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="12" className="text-center">No withdrawal requests found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WithdrawlRequests;
